'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COLORS = {
  black: '#000',
  blackLight: '#1b1b1b',
  grey: '#5a5a5a',
  grey2: '#4d5153',
  grey3: '#B5B4B4',
  grey4: '#333',
  grey5: '#666',
  grey6: '#5E5E5E',
  greyLight: '#d2d2d2',
  greyLight2: '#e1e1e1',
  greyLight3: '#f2f2f2',
  blue: '#2062d4',
  blue2: '#1c5bc4',
  blue3: '#31a3eb',
  blueLight: '#d2e6f5',
  blueLight2: '#d7f0f5',
  blueLight3: '#9accdc',
  blueLight4: '#dff4ec',
  blueLight5: '#d5eff5',
  blueLight6: '#EBE8F9',
  blueDark: '#003da5',
  red: '#d83521',
  redLight: '#ffeee6',
  green: '#cbd03b',
  green2: '#DBDE70',
  greenLight: '#E2F1DA',
  white: '#fff',
  whiteLight: '#f7f7f7',
  yellowLight: '#ffffdc',
  yellowLight2: '#e4e95e',
  yellowLight3: '#fbf9e4'
};

exports.default = COLORS;